import * as React from "react"
import { DrawerSeeker } from "@ui-seeker/core"

import { ModalCarouselImagesSeeker, ModalCarouselVideosSeeker } from "@components"
import { multimediaCarouselImages, multimediaCarouselImagesIsOpen, multimediaCarouselInitPos, multimediaCarouselVideos, multimediaCarouselVideosIsOpen } from "@signals"
import AdminNewListedDetailsDrawerContent from "./Content"
import { adminNewListedShowDetails, adminNewListedDetails } from "../@signals"


export default function AdminNewListedDetailsDrawer() {
	return <DrawerSeeker
		hideActions
		isOpen={adminNewListedShowDetails.value}
		controller={() => adminNewListedDetails.value = {}}
		title="SKU Details"
		width="30%"
	>
		<AdminNewListedDetailsDrawerContent/>

		<ModalCarouselImagesSeeker
			isOpen={multimediaCarouselImagesIsOpen.value}
			controller={ () => multimediaCarouselImages.value = [] }
			title='Images'
			multimedia={multimediaCarouselImages.value}
			initPos={multimediaCarouselInitPos.value}
		/>

		<ModalCarouselVideosSeeker
			isOpen={multimediaCarouselVideosIsOpen.value}
			controller={ () => multimediaCarouselVideos.value = [] }
			multimedia={multimediaCarouselVideos.value}
			initPos={multimediaCarouselInitPos.value}
		/>

	</DrawerSeeker>
}